/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getBookingsByTokenCartID } from "../../../actions/admin/booking";
import { useEffect } from "react";
import { useState } from "react";
import LanguageCard from "../../../components/layout-new-theme/LanguageCard";
import { getLocationByAddress } from "../../../actions/googleAPI";
import { useHistory, Link } from "react-router-dom";
import { setLanguage } from "../../../actions/admin/settings";
import {
  flywireUpdatePayment,
  flywireAddPayment,
  setDefaultPayment,
  deletePayment,
  flywireUpdatePaymentAuthUser
} from "../../../actions/admin/flywire";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch } from "react-redux";
import AlertModal from "../discover/_components/AlertModal";
import NewItemCardPaymentSuccess from "../../../components/layout-new-theme/cards/NewItemCardPaymentSuccess";
import {
  AddIcon,
  RadioSelectedIcon,
  RadioUnselectedIcon,
  ThreeDotsIcon,
} from "../../../components/icons";


const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/visa.svg";
const master_card_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/master-card.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/jcb.svg";
const american_ex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/american_ex.svg";
const logo_brand = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand.svg";
const logo_brand_name = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand-name.svg";
const logo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-cropped.png";
const logoMobile = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-cropped-mobile.png";

// The city Flywire needs for the cardholder. Some countries have no postcode lookup and some
// addresses have no city-level component, so this falls back rather than crashing the page.
const resolveCardholderCity = (locationResult, customer) => {
  const countriesWithoutPostcode = (process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE || "").split(",");
  if (countriesWithoutPostcode.includes(customer.country_code)) return customer.country;

  const addressParts = locationResult?.address_components || [];
  const cityPart = addressParts.find(
    (item) =>
      item.types.includes("administrative_area_level_2") ||
      item.types.includes("locality")
  );

  return cityPart?.long_name || addressParts[addressParts.length - 2]?.long_name || customer.country;
};

// A customer's saved cards live on individualDetail or businessDetail depending on their role.
const getSavedCards = (customer) => {
  const accountUser = customer?.userId;
  const accountDetail = accountUser?.role === "individual"
    ? accountUser?.individualDetail
    : accountUser?.businessDetail;
  return accountDetail?.paymentMethod || [];
};

const ChangePaymentMethod = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { token } = useParams();
  const [authenticated, setAuthenticated] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [bookings, setBookings] = useState([]);
  const [cartId, setCartId] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  useEffect(() => {
    const closeDropdowns = (e) => {
      if (!e.target.closest("[data-dropdown]")) setOpenDropdown(null);
    };
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [textModalAlert, setTextModalAlert] = useState("");
  const history = useHistory();

  const { t } = useTranslation();

  const callbackFlywire = async (result, ref) => {
    result.ref = ref;

    if (result.status === "success") {
      const updatePayment = await flywireUpdatePayment(result, token);

      setLoading(false);
      if (
        updatePayment.status === 200 &&
        updatePayment.data.status === "SUCCESS"
      ) {
        history.push(`/success-change-payment-method`);
      } else {
        setShowModalAlert(true);
        setTextModalAlert("Please Try Again");
      }
    }
  };

  const callbackFlywireAddPaymentMethod = async (result, ref) => {
    result.ref = ref;

    if (
      result.brand === bookings[0].flywireResponse.brand &&
      result.digits === bookings[0].flywireResponse.digits &&
      result.expirationMonth === bookings[0].flywireResponse.expirationMonth &&
      result.expirationYear === bookings[0].flywireResponse.expirationYear
    ) {
      setShowModalAlert(true);
      setTextModalAlert("Please Input Another Card");
    } else {
      if (result.status === "success") {
        const updatePayment = await flywireUpdatePayment(result, token);

        setLoading(false);
        if (
          updatePayment.status === 200 &&
          updatePayment.data.status === "SUCCESS"
        ) {
          history.push(`/success-change-payment-method`);
        } else {
          setShowModalAlert(true);
          setTextModalAlert("Please Try Again");
        }
      }
    }
  };

  const extractFirstAndLastName = async (fullName) => {
    // Split the full name into an array of strings
    const nameParts = fullName.trim().split(" ");

    // Extract the first name (first element of the array)
    const firstName = nameParts[0];

    // Extract the last name (last element of the array, if exists)
    const lastName =
      nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

    // Return an object containing the first name and last name
    return {
      firstName: firstName,
      lastName: lastName ? lastName : firstName,
    };
  };

  const changePaymentMethodHandler = async () => {
    setLoading(true);

    const { firstName, lastName } = await extractFirstAndLastName(
      bookings[0].customer.name
    );
    const zipCodeCheck = await getLocationByAddress(
      bookings[0].customer.postal_code,
      bookings[0].customer.country_code
    );

    const config = {
      env: process.env.REACT_APP_FLYWIRE_ENV,
      recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

      // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
      amount: 0,
      //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
      recurringType: "tokenization",
      recurringTypeRecipientCodes: [
        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
      ],

      // Specify the returnUrl or an onCompleteCallback handler
      // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

      // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
      firstName: firstName,
      lastName: lastName,
      email: bookings[0].customer.email,
      phone:
        bookings[0].customer.prefix_number + " " + bookings[0].customer.phone,
      address: bookings[0].customer.address,
      city: resolveCardholderCity(zipCodeCheck, bookings[0].customer),
      zip: bookings[0].customer.postal_code,
      country: bookings[0].customer.country_code,

      recipientFields: {
        booking_reference: `CB-${cartId}`,
        additional_information: null,
      },

      requestPayerInfo: false,
      requestRecipientInfo: false,

      // Control which tokenization options are available
      paymentOptionsConfig: {
        filters: {
          type: ["credit_card"],
        },
      },
      onCompleteCallback: function (args) {
        callbackFlywire(args, `CB-${cartId}`);
      },
      onInvalidInput: function (errors) {
        errors.forEach(function (error) {
          console.log(error.msg);
        });
      },
    };

    setLoading(false);
    const modal = window.FlywirePayment.initiate(config);
    modal.render();
  };

  const updatePaymentAuthenticatedUserHandler = async () => {
    const updatePayment = await flywireUpdatePaymentAuthUser(token, selectedPayment);

    setLoading(false);
    if (
      updatePayment.status === 200 &&
      updatePayment.data.status === "PAYMENT_HAS_NOT_BEEN_CHANGED"
    ) {
      window.scrollTo(0, 0)
    } else if (
      updatePayment.status === 200 &&
      updatePayment.data.status === "SUCCESS"
    ) {
      history.push(`/success-change-payment-method`);
    } else {
      setShowModalAlert(true);
      setTextModalAlert("Please Try Again");
    }
  }

  const addPaymentMethodHandler = async () => {
    setLoading(true);

    const { firstName, lastName } = await extractFirstAndLastName(
      bookings[0].customer.name
    );
    const zipCodeCheck = await getLocationByAddress(
      bookings[0].customer.postal_code,
      bookings[0].customer.country_code
    );

    const config = {
      env: process.env.REACT_APP_FLYWIRE_ENV,
      recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

      // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
      amount: 0,
      //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
      recurringType: "tokenization",
      recurringTypeRecipientCodes: [
        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
      ],

      // Specify the returnUrl or an onCompleteCallback handler
      // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

      // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
      firstName: firstName,
      lastName: lastName,
      email: bookings[0].customer.email,
      phone: bookings[0].customer.prefix_number + " " + bookings[0].customer.phone,
      address: bookings[0].customer.address,
      city: resolveCardholderCity(zipCodeCheck, bookings[0].customer),
      zip: bookings[0].customer.postal_code,
      country: bookings[0].customer.country_code,

      recipientFields: {
        booking_reference: `CB-${cartId}`,
        additional_information: null,
      },

      requestPayerInfo: false,
      requestRecipientInfo: false,

      // Control which tokenization options are available
      paymentOptionsConfig: {
        filters: {
          type: ["credit_card"],
        },
      },
      onCompleteCallback: function (args) {
        callbackFlywireAddPaymentMethod(args, `CB-${cartId}`);
      },
      onInvalidInput: function (errors) {
        errors.forEach(function (error) {
          console.log(error.msg);
        });
      },
    };

    setLoading(false);
    const modal = window.FlywirePayment.initiate(config);
    modal.render();
  };

  const setDefaultPaymentHandler = async (paymentId) => {
    const updatePayment = await setDefaultPayment(token, paymentId);

    setLoading(false);
    if (
      updatePayment.status === 200
    ) {
      setBookings(updatePayment.data);
    }
  }

  const deletePaymentHandler = async (paymentId) => {
    const updatePayment = await deletePayment(token, paymentId);

    setLoading(false);
    if (
      updatePayment.status === 200
    ) {
      setBookings(updatePayment.data);
    }
  }

  const getCardTypeByBrand = (type) => {
    if (type === "VISA") {
      return visa_icon;
    } else if (type === "MASTERCARD") {
      return master_card_icon;
    } else if (type === "AMERICAN EXPRESS") {
      return american_ex_icon;
    } else if (type === "JCB") {
      return jcb_icon;
    }
    return "Unknown";
  };

  const handleGetBookingsByTokenCartID = async (token) => {
    try {
      setError("");
      setLoading(true);
      const response = await getBookingsByTokenCartID(token);
      if (response.length === 0) {
        // Also how an expired link ends up here: the API rejects its token and nothing comes back.
        setError("ChangePaymentMethod.LinkUnavailable");
      } else if (!response[0].hasOwnProperty("flywireResponse")) {
        setError("No flywire payment method found for this");
        // } else if (response[0].paymentStatus !== "CHARGE_PENDING") {
        //   setError("Page unavailable");
      } else if (response[0].paymentMethodStatus === "CHANGED") {
        setError("ChangePaymentMethod.AlreadyUpdated");
      } else {
        setCartId(response[0].cartID);
        setBookings(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetBookingsByTokenCartID(token ?? "");
  }, [token]);


  useEffect(() => {
    try {
      const localStorageLang = localStorage.getItem("lang")
      if (!localStorageLang) {
        var userLang = navigator.language || navigator.userLanguage;
        if (userLang === "ja") {
          langChange("JP");
          moment.locale('ja');
        } else {
          langChange("EN");
          moment.locale('en');
        }
      } else {
        langChange(localStorage.getItem("lang"));
      }
    } catch {
      console.log("error")
    }
  }, []);

  const langChange = (lng) => {
    if (lng === "JP") {
      moment.locale('ja');
    } else {
      moment.locale('en');
    }
    i18n.changeLanguage(lng.toLowerCase());
    localStorage.setItem("lang", lng);
    dispatch(setLanguage(lng));
  };

  const getTotalPrice = () => {
    return bookings.reduce((acc, obj) => acc + (obj.discountedPrice ? obj.discountedPrice : obj.totalPrice), 0).toLocaleString()
  }

  if (loading) {
    return (
      <div className="tw:flex tw:justify-center tw:items-center tw:h-screen">
        <div className="tw:inline-block tw:w-8 tw:h-8 tw:align-[-0.125em] tw:border-4 tw:border-current tw:border-r-transparent tw:rounded-full tw:animate-spin tw:text-[#0d6efd]!" role="status">
          <span className="tw:sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw:flex tw:justify-center tw:items-center tw:h-screen">
        <h1 className="tw:px-4 tw:text-center">{t(error)}</h1>
      </div>
    );
  }

  const savedCards = getSavedCards(bookings[0].customer);

  return (
    <div style={{ backgroundColor: "#F6F6F6" }}>
      <AlertModal
        handleClose={() => setShowModalAlert(false)}
        show={showModalAlert}
        text={textModalAlert}
      />
      {/* Navbar */}
      <div className="tw:sticky tw:top-0 tw:z-[1020] no-print">
        <div className="tw:px-1 tw:md:px-12 tw:py-2 tw:bg-[#212529]">
          <div className="tw:!w-full tw:!flex tw:!items-center tw:!justify-between tw:!px-4 tw:md:!px-8">
            <Link className="tw:!inline-block" to={"/"}>
              <img className="tw:hidden! tw:lg:!block tw:!h-[56px] tw:!w-auto tw:!max-w-full" src={logo} alt="logo" />
              <img className="tw:block! tw:lg:!hidden tw:!h-[40px] tw:!w-auto tw:!max-w-full" src={logoMobile} alt="logo" />
            </Link>
            <div className="">
              <LanguageCard />
            </div>
          </div>
        </div>
      </div>
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:mt-12">
        <p className="fs-22 tw:text-[#212529]! fw-700 noto">
          {t("ChangePaymentMethod.Title")}
        </p>
        <div className="tw:bg-white tw:rounded-[0.375rem] tw:mt-4 tw:p-4">
          <p
            className="text-4E4E4E"
            dangerouslySetInnerHTML={{
              __html: t("ChangePaymentMethod.Desc"),
            }}
          ></p>
          <p className="text-4E4E4E">{t("ChangePaymentMethod.Desc2")}</p>
          <div className="registered-card tw:mb-4">
            <p className="tw:mt-4 fw-700 noto-sans">
              {t("ChangePaymentMethod.RegisteredCard")}
            </p>

            {bookings[0].customer.userId && (
              <>
                <div className="tw:rounded-[0.375rem] tw:border tw:border-[#dee2e6] border-1 border-color-EB001B tw:p-2 tw:mb-4 pointer">
                  <div className="tw:flex tw:justify-between tw:items-center">
                    <div className="tw:flex tw:items-center tw:gap-2 tw:py-1">
                      {selectedPayment === "" ? (
                        <RadioSelectedIcon color="#EB001B" className="tw:ml-2" />
                      ) : (
                        <RadioUnselectedIcon className="tw:ml-2" />
                      )}
                      <img
                        src={getCardTypeByBrand(
                          bookings[0].flywireResponse.brand
                        )}
                        alt=""
                        srcSet=""
                        height={13}
                      />
                      <p className="tw:m-0!">
                        •••• {bookings[0].flywireResponse.digits}, Exp.:{" "}
                        {bookings[0].flywireResponse.expirationMonth}/
                        {bookings[0].flywireResponse.expirationYear}
                      </p>
                      {
                        savedCards.find(item => item.isActive)?.token === bookings[0]?.flywireResponse?.token && (
                          <p className="tw:ml-2 bg-gold tw:rounded-[0.375rem] tw:text-white! tw:m-0! fs-10 tw:px-2 tw:py-1">
                            Default
                          </p>
                        )
                      }
                    </div>
                    <div className="tw:relative" data-dropdown>
                      <button
                        className="no-dropdown-toggle tw:bg-transparent tw:border-0 tw:cursor-pointer"
                        type="button"
                        onClick={() => setOpenDropdown(openDropdown === "current" ? null : "current")}
                        aria-expanded={openDropdown === "current"}
                      >
                        <ThreeDotsIcon className="tw:mr-2" />
                      </button>
                      <ul className={`tw:absolute tw:z-[1000] tw:min-w-[10rem] tw:py-2 tw:m-0! tw:text-base tw:text-[#212529] tw:text-left tw:list-none tw:bg-white tw:bg-clip-padding tw:border tw:border-[rgba(0,0,0,0.15)] tw:rounded-[0.375rem] tw:shadow-[0_0.5rem_1rem_rgba(0,0,0,0.175)] tw:right-0 tw:top-full ${openDropdown === "current" ? "tw:block!" : "tw:hidden!"}`}>
                        <li>
                          <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer" href="#">
                            {t("ChangePaymentMethod.SetAsDefault")}
                          </a>
                        </li>
                        <li>
                          <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer" href="#">
                            {t("ChangePaymentMethod.DeleteCard")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <p className="tw:mt-1 text-EB001B">
                  {t("ChangePaymentMethod.UnableProceedPayment")}
                </p>

                {
                  savedCards.map((v, ind) => {
                    return (v.brand !== bookings[0].flywireResponse.brand || v.cardNumber !== bookings[0].flywireResponse.digits) ? (
                      <div
                        className="tw:rounded-[0.375rem] border-bottom-gold tw:p-2 tw:mb-4 pointer"
                        onClick={() => {
                          setSelectedPayment(v.token)
                        }}
                      >
                        <div className="tw:flex tw:justify-between tw:items-center">
                          <div className="tw:flex tw:items-center tw:gap-2 tw:py-1">
                            {selectedPayment === v.token ? (
                              <RadioSelectedIcon className="tw:ml-2" />
                            ) : (
                              <RadioUnselectedIcon className="tw:ml-2" />
                            )}
                            <img
                              src={getCardTypeByBrand(
                                v.brand
                              )}
                              alt=""
                              srcSet=""
                              height={13}
                            />
                            <p className="tw:m-0!">
                              •••• {v.cardNumber}, Exp.:{" "}
                              {v.expirationMonth}/
                              {v.expirationYear}
                            </p>
                            {
                              v.isActive && (
                                <p className="tw:ml-2 bg-gold tw:rounded-[0.375rem] tw:text-white! tw:m-0! fs-10 tw:px-2 tw:py-1">
                                  Default
                                </p>
                              )
                            }
                          </div>
                          <div className="tw:relative" data-dropdown>
                            <button
                              className="no-dropdown-toggle tw:bg-transparent tw:border-0 tw:cursor-pointer"
                              type="button"
                              onClick={(e) => { e.stopPropagation(); setOpenDropdown(openDropdown === ind ? null : ind); }}
                              aria-expanded={openDropdown === ind}
                            >
                              <ThreeDotsIcon className="tw:mr-2" />
                            </button>
                            <ul className={`tw:absolute tw:z-[1000] tw:min-w-[10rem] tw:py-2 tw:m-0! tw:text-base tw:text-[#212529] tw:text-left tw:list-none tw:bg-white tw:bg-clip-padding tw:border tw:border-[rgba(0,0,0,0.15)] tw:rounded-[0.375rem] tw:shadow-[0_0.5rem_1rem_rgba(0,0,0,0.175)] tw:right-0 tw:top-full ${openDropdown === ind ? "tw:block!" : "tw:hidden!"}`} onClick={(e) => { e.stopPropagation(); setOpenDropdown(null); }}>
                              <li>
                                <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer"
                                  onClick={() => setDefaultPaymentHandler(v._id)}>
                                  {t("ChangePaymentMethod.SetAsDefault")}
                                </a>
                              </li>
                              <li>
                                <a className="tw:block! tw:w-full tw:py-1 tw:px-4 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:hover:bg-[#e9ecef] tw:cursor-pointer"
                                  onClick={() => deletePaymentHandler(v._id)}>
                                  {t("ChangePaymentMethod.DeleteCard")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ) : ""
                  })
                }

                <div className="tw:grid tw:md:block!">
                  <button
                    className="border-gold tw:py-4 tw:md:py-4 tw:px-12 text-4E4E4E fw-400 tw:rounded-[0.375rem] fs-14 noto-sans"
                    onClick={() => addPaymentMethodHandler()}
                  >
                    <div className="tw:flex tw:mx-4 tw:justify-center tw:items-center">
                      <AddIcon />
                      <span className="tw:ml-2">
                        {t("ChangePaymentMethod.AddPaymentMethod")}
                      </span>
                    </div>
                  </button>
                </div>
              </>
            )}
          </div>
          <div className="tw:grid tw:md:block!">
            <button
              className="bg-gold-light-100 tw:py-4 tw:md:py-4 tw:px-12 text-4E4E4E fw-400 tw:rounded-[0.375rem] fs-14 noto-sans"
              onClick={() => {
                if (bookings[0].customer.userId) {
                  updatePaymentAuthenticatedUserHandler()
                } else {
                  changePaymentMethodHandler()
                }
              }}
              // Guests have no saved cards to pick: this button is how they enter a new one.
              disabled={Boolean(bookings[0].customer.userId) && selectedPayment === ""}
            >
              <span className="tw:px-12">
                {t("ChangePaymentMethod.UpdatePaymentMethod")}
              </span>
            </button>
          </div>
        </div>
        <div className="tw:mt-4">
          <p className="fs-16 tw:text-[#212529]! fw-700 noto">
            {t("ChangePaymentMethod.ReservationDetails")}
          </p>
          <div className="tw:mt-4 tw:bg-white tw:rounded-[0.375rem]">
            <div className="tw:flex tw:justify-between tw:p-6">
              <p className="text-4E4E4E fw-700 fs-16 noto tw:m-0!">Total</p>
              <p className="text-4E4E4E fw-700 fs-16 noto tw:m-0!">
                JPY{" "}{getTotalPrice()}
              </p>
            </div>
          </div>
          {bookings.map((booking, index) => (
            <div className="tw:mx-auto tw:mt-4" key={index + 1}>
              <NewItemCardPaymentSuccess cart={booking} />
            </div>
          ))}
        </div>
      </div>
      <div className="tw:pb-12"></div>
    </div>
  );
};

export default ChangePaymentMethod;
